import axios from 'axios';
import jwt_decode from "jwt-decode";
import { setAuthToken } from '../../utils/setAuthToken';
import {setCurrentUser } from './userActions';
import {setPortfolioList} from './portfolioActions';

// Action for registering the user
export const registerUser = data => async dispatch => {
    try {
        const response = await axios.post("/api/users/register", data);
        return response;
    } catch (error) {
        console.log(error);
        return error.response;
    }
}

// Action for logging in the user
export const loginUser = data => async dispatch => {
    try {
        const response = await axios.post("/api/users/login", data);
        localStorage.setItem("authToken", response.data?.token);
        localStorage.setItem("currentUser", JSON.stringify(response.data?.user));
        setAuthToken(`Bearer ${response.data?.token}`)
        const decoded = jwt_decode(response.data?.token);
        dispatch(login(decoded));
        dispatch(setCurrentUser(response.data?.user));
        console.log(response.data.user?.portfolio);
        dispatch(setPortfolioList(response.data.user?.portfolio));
        return response;
    } catch (error) {
        console.log(error);
        return error.response;
    }
}

// Action for setting the login state in redux
export const login = data => ({
    type: "LOGIN_USER",
    payload: data
})

// Action for logging out the user
export const logout = () => ({
    type: "LOGOUT_USER",
})

// Action for forgot password
export const forgotPassword = data => async dispatch => {
    try {
        const options = {
            headers: {
                "Content-Type": "application/json"
            }
        }
       const response = await axios.post("/api/users/forgot-password", data, options);
       return response;
    } catch (error) {
        console.log(error);
        return error.response;        
    }
}

// Action for resetting the password
export const resetPassword = data => async dispatch => {
    try {
        const response = await axios.put("/api/users/reset-password", data);
        return response;
    } catch (error) {
        console.log(error);
        return error.response;
    }
}

// Action for updating the password
export const updateProfile = data => async dispatch => {
    try {
        const response = await axios.put("/api/users/update-profile", data);
        localStorage.setItem("currentUser", JSON.stringify(response.data.user));
        dispatch(setCurrentUser(response.data.user));
        return response;
    } catch (error) {
        console.log(error);
        return error.response;
    }
}